import { RedirectContainers, ResultAction } from '@cashier/cashier-model';

import { toHiddenFormConfiguration } from './toHiddenFormConfiguration';
import { toPaymentProgressConfiguration } from './toPaymentProgressConfiguration';
import { toProviderIframeConfiguration } from './toProviderIframeConfiguration';

interface ProviderIframeConfigurationInput {
  paymentMethod: {
    redirectContainer: RedirectContainers;
    name: string;
  };
  resultAction: ResultAction;
  loadingPageUrl: string;
}

export const PaymentProcessingConfigurator = {
  configure: ({
    paymentMethod,
    resultAction,
    loadingPageUrl,
  }: ProviderIframeConfigurationInput) => ({
    hiddenForm: toHiddenFormConfiguration({
      resultAction,
      paymentMethodContainer: paymentMethod.redirectContainer,
    }),
    providerIframe: toProviderIframeConfiguration({
      resultAction,
      paymentMethodContainer: paymentMethod.redirectContainer,
    }),
    paymentProgress: toPaymentProgressConfiguration({
      resultAction,
      loadingPageUrl,
    }),
  }),
};
